<!--开奖网图标-游戏投注页右下角-->
<template>
  <div class="GameKJW" v-if="isshow" v-drag>
    <div class="fixed-main position-relative">
      <van-icon name="close" class="closed-icon" @click.stop="setShow" />
      <a :href="opening_network" target="_blank">
        <div class="fixed-icon"></div>
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import {computed, defineComponent, ref} from 'vue'
import {useHot} from "/@/kernel-mn/stores/useHot.ts";

export default defineComponent({
  name: "GameKJW",
  setup() {
    const {hotData: {tenantInfo}} = useHot();
    // 开奖网地址
    const opening_network = computed(() => (tenantInfo.value?.tenant?.opening_network ?? ''));
    let isshow = ref(true);
    const setShow = () => {
      isshow.value = false;
    };
    return {
      opening_network,
      isshow,
      setShow,
    }
  },
})
</script>

<style scoped lang="scss">
.GameKJW {
  position: fixed;
  left: calc(100vw - #{px2rem(70)});
  top: calc(100% - #{px2rem(220)});
  z-index: 99;
  .closed-icon {
    position: absolute;font-size: px2rem(18);right: 0;top: px2rem(-8);padding: px2rem(4);
  }
  .fixed-icon {
    width: px2rem(70);height: px2rem(75);
    @include bgFull(publicImgUrl('btn_kjw.png'));
    a {
      display: block;
    }
  }
}
.themeKYMN {
  .GameKJW {
    left: calc(100vw - #{px2rem(80)});
    top: calc(100% - #{px2rem(200)});
    .fixed-icon {
      width: px2rem(80);height: px2rem(67);
      @include bgFull(publicImgUrl('btn_kjw1.png'));
    }
  }
}
</style>